import { Fragment } from 'react';
import { Heading, Paragraph } from '@zillow/constellation-10';
import { compact, isEmpty } from 'lodash-es';
import type { Answers, Vehicle } from '../../../../../models/rental-application';
import { hasVehicleDetails } from '../../../../../utils/capps-mappers';

type Props = {
  answers: Answers;
};

function toYesNo(value: boolean | null | undefined) {
  return value ? 'Yes' : 'No';
}

function getVehicleName(vehicle: Vehicle) {
  return compact([vehicle.make?.trim(), vehicle.model?.trim()]).join(' ') || '-';
}

export function VehiclesOverview({ answers }: Props) {
  const hasVehicles = answers.vehicles?.hasVehicles;
  const vehicles = (answers.vehicles?.vehicles ?? []).filter(hasVehicleDetails);

  if (hasVehicles == null) {
    return null;
  }

  if (!hasVehicles || isEmpty(vehicles)) {
    return <Paragraph>{hasVehicles ? 'Yes' : 'No vehicles'}</Paragraph>;
  }

  if (vehicles.length === 1) {
    const [vehicle] = vehicles;
    return (
      <>
        <OverviewField label="Make / Model" value={getVehicleName(vehicle)} />
        <OverviewField label="Parking spot" value={toYesNo(vehicle.isParkingSpotNeeded)} />
        <OverviewField label="EV charging" value={toYesNo(vehicle.isEvChargingNeeded)} />
      </>
    );
  }

  return (
    <>
      {vehicles.map((vehicle, index) => (
        <Fragment key={index}>
          <Heading level={6} css={{ marginTop: 'tighter', marginBottom: 'tighter' }}>
            Vehicle #{index + 1}
          </Heading>
          <Paragraph>{getVehicleName(vehicle)}</Paragraph>
          <Paragraph>Parking spot: {toYesNo(vehicle.isParkingSpotNeeded)}</Paragraph>
          <Paragraph>EV charging: {toYesNo(vehicle.isEvChargingNeeded)}</Paragraph>
        </Fragment>
      ))}
    </>
  );
}

function OverviewField({ label, value }: { label: string; value: string }) {
  return (
    <>
      <Heading level={6} css={{ marginTop: 'tighter', marginBottom: 'tighter' }}>
        {label}
      </Heading>
      <Paragraph>{value}</Paragraph>
    </>
  );
}
